import { reactive } from 'vue';

export const authStore = reactive({
  showLoginModal: false,
  user: null,
  token: localStorage.getItem('token'),

  show() {
    this.showLoginModal = true;
  },

  hide() {
    this.showLoginModal = false;
  },

  login(userData, token) {
    this.user = userData;
    this.token = token;
    localStorage.setItem('currentUser', JSON.stringify(userData));
    localStorage.setItem('token', token);
    localStorage.setItem('isLoggedIn', 'true');
    this.hide();
  },

  logout() {
    this.user = null;
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('isLoggedIn');
  },

  checkLoginStatus() {
    const user = localStorage.getItem('currentUser');
    if (user) {
      this.user = JSON.parse(user);
    }
    this.token = localStorage.getItem('token');
  }
});